export type CitationListFilterValue = string | number | boolean | (string | number)[];

export function mergeCitationsListFilters(
  userPropertyId: number | undefined,
  filters: Record<string, unknown> = {},
): Record<string, CitationListFilterValue> {
  const merged: Record<string, CitationListFilterValue> = {
    context_property_id: userPropertyId ?? 0,
  };

  for (const [key, value] of Object.entries(filters)) {
    if (key === "context_property_id") continue;
    if (value === undefined || value === null || value === "") continue;
    if (Array.isArray(value) && value.length === 0) continue;
    merged[key] = value as CitationListFilterValue;
  }

  return merged;
}
